import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "./common/Navbar";
import Footer from "./common/Footer";
import HeroBanner from "./home/HeroBanner";
import CategoryGrid from "./home/CategoryGrid";
import FeaturedProducts from "./home/FeaturedProducts";
import Testimonials from "./home/Testimonials";
import Loader from "./common/Loader";
import { getAllProducts } from "../services/api";

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [coupon, setcoupon] = useState("true");
  // const [Discount, setDiscount] = useState(0);



  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getAllProducts();
        if (response.data.data) {
          setProducts(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // const applyCoupon = () => {
  //   if (coupon === "WELCOME20") {
  //     setDiscount(0.2); // 20%
  //   } else {
  //     alert("Invalid Coupon");
  //     setDiscount(0);
  //   }
  // };
  if (loading) {
    return <Loader message="Loading Luxury Collection..." />;
  }

  // Best sellers (first 4 products)
  const bestSellers = products.slice(0, 4);

  // New arrivals (last 4 products)
  const newArrivals = [...products].reverse().slice(0, 4);

  return (
    
    <Box sx={{ minHeight: "100vh", bgcolor: "#f9f6f2" }}>
      {/* <TopBar/> */}
              <Navbar />

      {/* Hero Banner */}
      <HeroBanner />

      {/* Category Grid */}
      <CategoryGrid />

      {/* Best Sellers */}
      {bestSellers.length > 0 && (
        <FeaturedProducts
          title="Best Sellers"
          subtitle="Most Loved Jewellery"
          products={bestSellers}
          viewAllLink="/filter/All"
          bgColor="#ffffff"
        />
      )}

      {/* Promotional Banner */}
      <Box
        sx={{
          py: 10,
          background: "linear-gradient(135deg, #000000 0%, #1c1c1c 100%)",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <Box sx={{ maxWidth: 700, mx: "auto", px: 3 }}>
          <Box
            component="span"
            sx={{
              display: "inline-block",
              bgcolor: "rgba(212, 175, 55, 0.15)",
              color: "#d4af37",
              px: 4,
              py: 1,
              borderRadius: 10,
              fontSize: "0.9rem",
              fontWeight: 600,
              mb: 3,
              letterSpacing: 1,
            }}
          >
            LIMITED TIME OFFER
          </Box>

          <Box
            component="h2"
            sx={{
              fontSize: { xs: "1.8rem", md: "2.8rem" },
              fontWeight: 700,
              mb: 2,
              m: 0,
              color: "#ffffff",
            }}
          >
            Get 20% Off on Your First Order
          </Box>

          <Box
            component="p"
            sx={{
              fontSize: "1.2rem",
              opacity: 0.9,
              mb: 4,
            }}
          >
            Use code{" "}
            <strong style={{ color: "#d4af37", letterSpacing: 1 }}>
              WELCOME20
            </strong>{" "}
            at checkout
          </Box>
        </Box>
      </Box>

      {/* New Arrivals */}
      {newArrivals.length > 0 && (
        <FeaturedProducts
          title="New Arrivals"
          subtitle="Freshly Added Designs"
          products={newArrivals}
          viewAllLink="/filter/All"
          bgColor="#ffffff"
        />
      )}

      {/* Testimonials */}
      <Testimonials />

      {/* Footer */}
      <Footer />
    </Box>
  );
};

export default Home;
